<style lang='scss' src='./DraggableTaskList.scss' scoped ></style>
<template src='./DraggableTaskList.html'></template>

<script>
import { mapState, mapMutations } from 'vuex';
import { updateTaskStatus } from '@/api/index';
import draggable from 'vuedraggable';
import VueContext from 'vue-context';
import  'vue-context/dist/css/vue-context.css';
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';

export default {
  name: 'DraggableTaskList',
  components: {
    draggable,
    UserAvatar,
    VueContext,
  },
  props: {
    tasks: {
      type: Array,
      required: true,
    },
    taskStatus: {
      type: String,
      required: true,
    },
    onSelectTask: {
      type: Function,
      required: true,
    },
    deleteTask: {
      type: Function,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return ({
    });
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "tasks",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    ...mapState('TaskBoard', {
      allTasks: (state) => state.tasks,
    }),
  },

  methods: {
    getAssignee(task){
      if(task.users == null || task.users == 'undefined' || task.users.length <= 0 || task.users.length > 1){
        return null;
      }
      return task.users[0];
    },

    hasMultipleUsers(task){
      if(task.users != null && task.users != 'undefined' && task.users.length > 1){
        return true;
      }
      return false;
    },

    openContextMenu($event, task) {
      document.getElementById('taskTitle').click(); //Click on title to close other context menus
      this.$refs.contextMenu.open($event, task);
    },

    async onChange(evt) {
      const action = Object.keys(evt)[0];
      
      if (action === 'added' || action === 'moved' ) {
        const task = evt[action].element;
        let newOrden = evt[action].newIndex;

        if (newOrden !== 0) {
          const previuosTask = this.allTasks[this.taskStatus][newOrden - 1];
          newOrden = previuosTask.orden + 1 ;
        }

        const payload = {
          status: this.taskStatus,
          orden: newOrden,
        };
        
        const taskSaved = await updateTaskStatus(payload, task.task_id, false);
        this.moveTask(taskSaved);
      }
    },

    ...mapMutations('TaskBoard', ['moveTask']),
  },

  beforeCreate() {},

  created() {},

  mounted() {},

  beforeDestroy() {},

};
</script>
